import type { TFunction } from 'i18next';

/** A contact handle as staff should read it: website visitor IDs are internal and never shown raw. */
export function handleLabel(t: TFunction, type: string, value: string): string {
  if (type === 'web_user_id') {
    if (value.startsWith('user:')) return t('inbox.handle.signedInVisitor', { id: value.slice(5) });
    return t('inbox.handle.anonymousVisitor');
  }
  // Google gives no reviewer id; the review itself stands in for one and is not shown.
  if (type === 'google_reviewer') return t('inbox.handle.googleReviewer');
  return value;
}
